import {EventEmitter, Injectable, OnDestroy} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CommandBase, ContentScope, PlatformCommand} from "@shared/commands/command-base";
import {DialogModel} from "@shared/models/dialog.model";
import {take, takeUntil} from "rxjs/operators";
import {DownloadType} from "@features/dac6-reporter/Fields";
import {DialogService} from "@shared/services/dialog-service";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {CommandService} from "@core/services/command.service";
import {
  FilingErrorReportComponent
} from "@features/dac6-reporter/components/filing-error-report/filing-error-report.component";
import {MatDialog} from "@angular/material/dialog";
import {Configuration} from "@shared/models/configuration";
import {Api} from "@shared/constants/common-field.constants";
import {TransmitFileCommand} from "@features/dac6-reporter/components/transmissions/commands/transmission.command";
import {FileDialogComponent} from "@features/file-manager/component/file-dialog/file-dialog.component";
import {SnackBarService} from "@core/services/snack-bar.service";
import {NotificationMessageModel} from "@shared/models/notification-message.model";
import {ExcelExportSourceFileDownloadAction} from "@features/dac6-reporter/store/actions/dac6-reporter.actions";
import {Store} from "@ngrx/store";
import {IDac6ReporterState} from "@features/dac6-reporter/store/reducers/dac6-reporter.reducer";
import {FormAttachmentToFilingTaskCommand} from "@features/dac6-reporter/commands/dac6-reporter.command";
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {TaskManagerService} from "@features/task-manager/services/task-manager.service";
import {Dac6ReporterApiService} from "@features/dac6-reporter/services/dac6-reporter.service";
import {Router} from "@angular/router";
import {Subject} from "rxjs";

@Injectable({providedIn: 'root'})
export class FormFilingManagerService implements OnDestroy{
  unSubscribe$ = new Subject<void>();
  constructor(private router: Router,  private dac6ApiService: Dac6ReporterApiService,private taskManagerService:TaskManagerService,private store: Store<IDac6ReporterState>,private snackBarService:SnackBarService, private dialog: MatDialog,private httpClient: HttpClient, private dialogService: DialogService,private fuseSplashScreenService: FuseSplashScreenService,private commandService:CommandService) {
  }


  async handleDownloadNextAction(transmitData:TransmitData) {
    if (transmitData.transmitToAuthority) {
      const defaultExportOption = this.getExportDownloadOption(transmitData.filingExportOptions,transmitData.rightElementsCount);
      if(defaultExportOption.MetaData['HasReferenceTitleUi']){
        const dialogModel = DialogModel.create('Export Report', 'MxHallmarkReportExportInputDialogComponent', {}, '600px', '600px');
        this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(state=>{
          this.fuseSplashScreenService.show();
          const command = new FillingManagerFormExportCommand(transmitData.countryCode, transmitData.formId, transmitData.executionId, defaultExportOption.DownloadType, true, defaultExportOption.MetaData['Process'], !transmitData.showOriginal);
          command.dictionary['FormSourceType'] = transmitData.formSourceType;
          command.dictionary['ScenarioType'] = transmitData.scenarioType;
          this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(commandState => {
            if (commandState) {
              this.fuseSplashScreenService.hide();
              if (commandState.Payload.HasError) {
                this.showErrorReportDialog(commandState,transmitData);
              } else {
                this.openTransmitFillingDialoge(transmitData,commandState);
              }
            }
          });
        })
      }else{
        this.fuseSplashScreenService.show();
        let command = new FillingManagerFormExportCommand(transmitData.countryCode, transmitData.formId, transmitData.executionId, defaultExportOption.DownloadType, true, defaultExportOption.MetaData['Process'], !transmitData.showOriginal);
        command.dictionary['FormSourceType'] = transmitData.formSourceType;
        command.dictionary['ScenarioType'] = transmitData.scenarioType;
        this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(commandState => {
          if (commandState) {
            this.fuseSplashScreenService.hide();
            if (commandState.Payload.HasError) {
              this.showErrorReportDialog(commandState,transmitData);
            } else {
              this.openTransmitFillingDialoge(transmitData,commandState);
            }
          }
        });
      }
    }
    else {
      this.showDownloadDialog(transmitData);
    }
  }

  getExportDownloadOption(filingExportOptions,rightElementsCount) {
    let downloadType = filingExportOptions.DefaultDownloadType;
    let selectedExportOption;
    if(rightElementsCount > 1){
      let hasMergedItems = false;
      filingExportOptions.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          hasMergedItems = true;
        }
      });
      if( hasMergedItems ) downloadType = DownloadType.XML;
      else if( downloadType !== DownloadType.fvie ) downloadType = DownloadType.ZIP;
    }
    else {
      if ( downloadType === DownloadType.ZIP ) downloadType = DownloadType.XML;
    }
    selectedExportOption = filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    if(!selectedExportOption){
      downloadType = filingExportOptions.DefaultDownloadType;
      selectedExportOption = filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    }
    return selectedExportOption;
  }
  showErrorReportDialog(exportCommandResopnse,transmitData:TransmitData) {
    const dialogRef = this.dialog.open(FilingErrorReportComponent, {
      minWidth: '750px',
      maxWidth: '850px',
      data: {
        transmitToAuthority: transmitData.transmitToAuthority,
        exectionId: transmitData.executionId,
        formId: transmitData.formId,
        hasError: exportCommandResopnse.Payload.HasError,
        rightElementsCount: transmitData.rightElementsCount,
        countryCode: transmitData.countryCode,
        targetApi: Api.FilingManagerApi
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: string) => {
      if (result) {
        switch (result) {
          case 'download-form':
            this.showDownloadDialog(transmitData, exportCommandResopnse);
            break;
          case 'transmit-to-authority':
            this.openTransmitFillingDialoge(transmitData,exportCommandResopnse);
            break;
        }
      }
    });
  }
  showDownloadDialog(transmitData:TransmitData, exportCommandResopnse = null) {
    const dialogModel: DialogModel = DialogModel.create(
      'Download or Save',
      'FilingExportOptionsDialogComponent',
      {
        clickAction: new EventEmitter<any>(),
        selectedItemCount: transmitData.rightElementsCount,
        countryCode: transmitData.countryCode,
        scenarioType: transmitData.scenarioType,
        options: transmitData.filingExportOptions,
        transmission: transmitData.transmitToAuthority
      }
    );
    dialogModel.minWidth = '520px';
    dialogModel.maxWidth = '520px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
      console.log(item);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unSubscribe$)).subscribe(option => {
      console.log(option);
      if (option.includes('SaveToDrive')) {
        const fileType = option.split('-')[1];
        const metadata = { };
        if(transmitData.scenarioType) {
          metadata['ScenarioType'] = transmitData.scenarioType;
        }
        if(transmitData.cells['DriveId']?.value) {
          metadata['DriveId'] = transmitData.cells['DriveId'].value;
        }
        if(transmitData.cells['FolderId']?.value) {
          metadata['FolderId'] = transmitData.cells['FolderId'].value;
        }

        if (exportCommandResopnse && exportCommandResopnse.Payload.MetaData['IsDemo'] === true) {
          metadata['IsDemo'] = exportCommandResopnse.Payload.MetaData['IsDemo'];
          metadata['DemoMessage'] = exportCommandResopnse.Payload.MetaData['DemoMessage'];
        }

        this.saveToDrive(transmitData.executionId, fileType, dialogModel.input['ExportOption'], metadata,transmitData);
      } else {
        this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse,transmitData);
      }
    });
  }
  openTransmitFillingDialoge(transmitData:TransmitData,exportCommandResopnse) {
    if (exportCommandResopnse.Payload &&
      exportCommandResopnse.Payload.MetaData &&
      exportCommandResopnse.Payload.MetaData.transmitKey &&
      exportCommandResopnse.Payload.MetaData.transmitKey.length > 0) {
      const transmitKey = exportCommandResopnse.Payload.MetaData.transmitKey;
      this.fuseSplashScreenService.show();
      this.dac6ApiService.getAgreementByCountryCode(transmitData.cells['CountryCode'].value).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if (response) {
          const dialogModel: DialogModel = DialogModel.create(
            'Transmit Form(s)',
            'ConfirmTransmissionDialogComponent',
            { data: response }
          );
          dialogModel.okCaption = 'Transmit';
          this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe((item: any) => {
            if (item.action === 'OK') {
              let fieldValues = {};
              if(item &&
                item.data &&
                item.data.input &&
                item.data.input.TransmissionData &&
                item.data.input.TransmissionData.cells) {
                fieldValues = this.getDictionary(item.data.input.TransmissionData.cells);
              }
              const command = new TransmitFileCommand(transmitKey,transmitData.cells['CountryCode'].value, fieldValues);
              this.fuseSplashScreenService.show();
              this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
                this.fuseSplashScreenService.hide();
                this.router.navigate(['dac6-reporter/transmissions']);
              });
            }
          });
        }
      });
    }
    else {
      const title = transmitData.rightElementsCount == 1 ? 'Transmit Form' : 'Transmit Form(s)';
      const dialogModel: DialogModel = DialogModel.create(
        title,
        'TransmitFormDialogComponent',
        {
          onClick: new EventEmitter<any>(),
          countryCode: transmitData.cells['CountryCode'].value,
          sourceType: transmitData.cells['SourceType']?.value,
          targetApi: Api.FilingManagerApi
        }
      );
      dialogModel.okCaption = 'Next';
      this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
        console.log('transmit:', item);
        if (item && item.action === 'OK') {
          this.downloadOrAttachToTask(transmitData, exportCommandResopnse);
        }
      });
      dialogModel.input['onClick'].pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
        console.log(item);
        if (item && item.type === 'Command') {
          this.showDownloadDialog(transmitData, exportCommandResopnse);
        }
      });
    }
  }
  getDictionary(dict: any) {
    const ret = {};
    for (const key in dict) {
      ret[key] = dict[key].value;
    }
    return ret;
  }
  downloadOrAttachToTask(transmitData:TransmitData, exportCommandResopnse) {
    const dialogModel: DialogModel = DialogModel.create(
      'Download or Attach to Task',
      'FilingDownloadOrAttachmentToTaskComponent',
      {
        clickAction: new EventEmitter<any>(),
        selectedItemCount: transmitData.rightElementsCount,
        countryCode: transmitData.cells['CountryCode'].value,
        scenarioType: transmitData.cells['ScenarioType']?.value,
        options: transmitData.filingExportOptions,
        transmission: transmitData.transmitToAuthority
      }
    );
    dialogModel.minWidth = '520px';
    dialogModel.maxWidth = '520px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(item => {
      console.log(item);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unSubscribe$)).subscribe(option => {
      console.log(option);
      if (option.includes('AttachtoTask')) {
        const fileType = option.split('-')[1];
        this.attachToTask(fileType, dialogModel.input['ExportOption'], exportCommandResopnse,transmitData);
      } else {
        this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse,transmitData);
      }
    });
  }
  private attachToTask(fileType: string, exportOption, exportCommandResopnse = null,transmitData:TransmitData) {

    this.attach(transmitData.formId, transmitData.executionId, fileType, exportOption,transmitData);
  }
  private attach(formId: any, executionId: any, fileType: any, exportOption: any,transmitData:TransmitData) {
    if ( exportOption.DownloadType === DownloadType.fvie ) {
      exportOption = transmitData.filingExportOptions.ExportOptions.find(option => option.DownloadType === DownloadType.XML );
      fileType = DownloadType.XML;
    }
    const countryCode = transmitData.cells['CountryCode'].value;
    const taskDetails = transmitData.cells['DAC6FilingStatus']?.value;
    const caseId = transmitData.cells['CaseId']?.value;
    const fileName = `${caseId}${countryCode}.${fileType}`;
    const scenarioType = transmitData.cells['ScenarioType']?.value; //will remove scenarioType once GMT-Forms will move to GMT
    const command = new FormAttachmentToFilingTaskCommand(countryCode, formId, executionId, fileType, 'Dac6-Filling', exportOption.MetaData['Process']);
    command.scope = ContentScope.Company;
    command.parameters = {
      'ScenarioType': scenarioType
    };//will remove scenarioType once GMT-Forms will move to GMT
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Attachment added successfully.');
      if (data && data.Payload) {
        this.taskManagerService.openTaskByTaskId(data.Payload.Id, GraphqlContentScope.getScope(data.Payload.Scope));
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError(err.Payload);
    });
  }
  downloadForm(option: string, exportOption, exportCommandResponse,transmitData:TransmitData) {
    if (!exportCommandResponse) {
      if(exportOption.MetaData['HasReferenceTitleUi']){
        const dialogModel = DialogModel.create('Export Report', 'MxHallmarkReportExportInputDialogComponent', {}, '600px', '600px');
        this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(state=>{
          const command = new FillingManagerFormExportCommand(transmitData.countryCode, transmitData.formId, transmitData.executionId, exportOption.DownloadType, true, exportOption.MetaData['Process'], !transmitData.showOriginal);;
          command.api
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(commandState => {
            if (commandState) {
              this.fuseSplashScreenService.hide();

             let fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
                transmitData.executionId, exportOption.MetaData['Process']);

              this.store.dispatch(new ExcelExportSourceFileDownloadAction(commandState.Payload));
              this.commandService.executePlatformCommand(fileManagerFormExportActivityCommand);
            }
          });
        })
      }
      else{
        let command = new FillingManagerFormExportCommand(transmitData.countryCode, transmitData.formId, transmitData.executionId, exportOption.DownloadType, true, exportOption.MetaData['Process'], !transmitData.showOriginal);;;
        command.dictionary['FormSourceType'] = transmitData.cells['FormSourceType'] ? transmitData.cells['FormSourceType'].value : '';
        command.dictionary['ScenarioType'] = transmitData.cells['ScenarioType'] ? transmitData.cells['ScenarioType'].value : '' ;
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(commandState => {
          if (commandState) {
            this.fuseSplashScreenService.hide();

            let fileManagerFormExportActivityCommand =  this.generateFileMangerExportActivityCommand(commandState,
              transmitData.executionId, exportOption.MetaData['Process']);

            this.store.dispatch(new ExcelExportSourceFileDownloadAction(commandState.Payload));
            // if (!this.targetApi) {
              this.commandService.executePlatformCommand(fileManagerFormExportActivityCommand);
          //  }
          }
        });
      }
    } else {
      if (exportCommandResponse.Payload.MetaData['IsDemo'] === true) {
        this.snackBarService.showError(exportCommandResponse.Payload.MetaData['DemoMessage']);
      } else {
        this.store.dispatch(new ExcelExportSourceFileDownloadAction(exportCommandResponse.Payload));
        let fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(exportCommandResponse,
          transmitData.executionId, exportOption.MetaData['Process']);

          this.commandService.executePlatformCommand(fileManagerFormExportActivityCommand);

      }
    }
  }
  saveToDrive(executionId: string, fileType: string, exportOption: any, metadata: {},transmitData) {
    if (metadata['IsDemo'] === true) {
      this.snackBarService.showError(metadata["DemoMessage"]);
      return;
    }
    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        itemsUrlIndex: 1,
        type: metadata['ScenarioType'] ? 'DirectoryEntries' : 'SharedDrives',
        folderId: metadata['FolderId'] ? metadata['FolderId'] : '',
        driveId: metadata['DriveId'] ? metadata['DriveId'] : '',
        isFileSelector: false,
        viewType: 'TeamDrive',
        title: 'Select Folder'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: any) => {
      const selectedFolderInfo = result;
      if (selectedFolderInfo && selectedFolderInfo !== '') {
        const parentId = selectedFolderInfo.id;
        const driveId = selectedFolderInfo.cells.ItemId.value;
        const dictionary = {};
        if(metadata['ScenarioType']) {
          dictionary['ScenarioType'] = metadata['ScenarioType'];
        }

        let command = new FillingManagerFormExportCommand(transmitData.countryCode, transmitData.formId, transmitData.executionId, transmitData.defaultExportOption.DownloadType, true, transmitData.defaultExportOption.MetaData['Process'], !transmitData.showOriginal);
        command.dictionary['ScenarioType'] = metadata['ScenarioType'] ? metadata['ScenarioType'] : '';
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe((commandState) => {
          this.fuseSplashScreenService.hide();

          let fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
            transmitData.executionId, exportOption.MetaData['Process']);

       //   if (!this.targetApi) {
            this.commandService.executePlatformCommand(fileManagerFormExportActivityCommand);
         // }

          this.snackBarService.showInformation('Form(s) are saved to drive successfully.');
        });
      }
    });
  }
  generateFileMangerExportActivityCommand(response: NotificationMessageModel, executionId: string, process: string): PlatformCommand{
    const command = new PlatformCommand("ExportFormActivityCommand", Api.FilingManagerApi);

    command.fieldValues["FileName"] = response.Payload.FileName;
    command.fieldValues["FileId"] = response.Payload.FileId;
    command.fieldValues["Process"] = process;
    command.fieldValues["ExecutionId"] = executionId;

    return command;
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}

export class FillingManagerFormExportCommand extends CommandBase {
  api: string = Api.FilingManagerApi;
  constructor(public countryCode, public formId: string, public executionId: string,
              public downloadSelectionType: string, public IsValidationNeed: boolean,
              public process: string, public isTranslated: boolean, public dictionary = {},
              public parentId: string = '', public driveId: string = '',
              public isSaveToDrive: boolean = false) {
    super(`${Configuration.getConfig(Api.FilingManagerApi)}Export/ExportForm`);
  }
}
export class TransmitData {
  formSourceType: any;
  scenarioType: any;
  transmitToAuthority: boolean;
  filingExportOptions: any;
  rightElementsCount: any;
  countryCode: string;
  formId: string;
  executionId: string;
  showOriginal: boolean;
  cells:any;

  constructor(
    formSourceType: any,
    scenarioType: any,
    transmitToAuthority: boolean,
    filingExportOptions: any,
    rightElementsCount: any,
    countryCode: string,
    formId: string,
    executionId: string,
    showOriginal: boolean,
    cells:any
  ) {
    this.formSourceType = formSourceType;
    this.scenarioType = scenarioType;
    this.transmitToAuthority = transmitToAuthority;
    this.filingExportOptions = filingExportOptions;
    this.rightElementsCount = rightElementsCount;
    this.countryCode = countryCode;
    this.formId = formId;
    this.executionId = executionId;
    this.showOriginal = showOriginal;
    this.cells = cells
  }
}
